export default "__VITE_ASSET__dc6278ed__"